import React from "react";
import { getMarket } from "../config/markets.js";

const CountryFlag = ({
  country,
  width = 22,
  className,
  style,
  decorative = false,
}) => {
  const market = getMarket(country);

  return (
    <img
      src={market.flagUrl}
      alt={decorative ? "" : `${market.name} flag`}
      aria-hidden={decorative || undefined}
      className={className}
      draggable={false}
      width={width}
      height={Math.round(width * 2 / 3)}
      style={{
        width,
        height: Math.round(width * 2 / 3),
        display: "inline-block",
        flexShrink: 0,
        objectFit: "cover",
        border: "1px solid rgba(15, 23, 42, 0.16)",
        borderRadius: 2,
        verticalAlign: "middle",
        ...style,
      }}
    />
  );
};

export default CountryFlag;
